export enum TaskTransition {
  reject = 'reject',
  accept = 'accept',
}
